import { motion } from "framer-motion";

export function FullBleedHero({ image, alt, eyebrow, title, subtitle, children, minH = "82vh" }) {
  return (
    <section className="relative flex items-center overflow-hidden border-b border-white/10" style={{ minHeight: minH }}>
      <img src={image} alt={alt} className="absolute inset-0 w-full h-full object-cover object-right" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #050B14 0%, rgba(5,11,20,0.92) 30%, rgba(5,11,20,0.55) 55%, rgba(5,11,20,0.05) 80%)" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, #050B14 0%, rgba(5,11,20,0) 35%)" }} />
      <div className="relative px-6 md:px-12 lg:px-20 py-24 w-full">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-2xl">
          {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
          <h1 className="font-display text-5xl md:text-7xl text-white tracking-tight leading-[1.02]">{title}</h1>
          {subtitle && <p className="text-ebg-muted mt-7 text-lg leading-relaxed max-w-xl">{subtitle}</p>}
          {children}
        </motion.div>
      </div>
    </section>
  );
}
